import { useEffect, useState } from "react";
import Creatable from "react-select/creatable";
import { components } from "react-select";
import { useDispatch, useSelector } from "react-redux";
// import { getAdvertiser } from "../../Redux/Actions/CCreativeUploadActions";
import { IReduxState } from "../../../utils/types";
import {
  AddNewDomainAction,
} from "../../../Redux/Actions/DomainAction";

const Option = (props: any) => {
    return (
      <div>
        <components.Option {...props}>
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

const AccountMgmtTab = () => {
    const dispatch = useDispatch();
    const domainState = useSelector((state: IReduxState) => state.Domain);
    const [domainList, setDomainList] = useState<any>([]);
    const [selectedDomain, setSelectedDomain] = useState<any>([]);
    useEffect(() => {
        if (domainState?.domainList) {
          const temp: any = [];
          domainState?.domainList.map((obj: any) => {
            return temp.push({ value: obj.domain_name, label: obj.domain_name });
          });
    
          setDomainList(temp);
        }
      }, [domainState?.domainList]);

      const handleChange = (selected: any) => {
        setSelectedDomain(selected);
      };
      useEffect(() => {
        if (selectedDomain?.__isNew__)
          dispatch(AddNewDomainAction({ domain_name: selectedDomain.value }));
      }, [selectedDomain, dispatch]);
    return (
        <>
            <div className="select-domins">
                <p>Domain Access</p>
                <div className="input-box">
                  <Creatable
                    className="input-box-item"
                    name="source"
                    options={domainList}
                    closeMenuOnSelect={true}
                    hideSelectedOptions={true}
                    components={{ Option }}
                    onChange={handleChange}
                    isClearable
                  // value={optionSelected}
                  />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-check"
                    viewBox="0 0 16 16"
                  >
                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
                  </svg>
                </div>
              </div>
        </>
    )
}
export default AccountMgmtTab;